import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import axios from "axios";

const SUBSCRIBE_URL = "https://emailapp.leadersinternational.org/subscribe";
const LOCATION_URL =
  "https://ipgeolocation.abstractapi.com/v1/?api_key=4123cd5312bc4ed286a6fc00e1eed3e3&fields=country_code";
const COUNTRIES_URL = "https://restcountries.com/v2/all?fields=name,alpha2Code";
const bouncedMessage = "<h2>Email address is bounced.</h2>";

const formData = {
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  message: "",
  countries: [],
  userCountry: "",
  subscribeForm: {},
};

const subscribeAdapter = createEntityAdapter();

const initialState = subscribeAdapter.getInitialState(
  Object.assign({}, formData)
);

export const fetchCountries = createAsyncThunk(
  "subscribe/fetchCountries",
  async () => {
    const response = await axios.get(COUNTRIES_URL);
    return response.data;
  }
);

export const fetchUserCountry = createAsyncThunk(
  "subscribe/fetchUserCountry",
  async () => {
    const response = await axios.get(LOCATION_URL);
    return response.data;
  }
);

export const submitSubscribeForm = createAsyncThunk(
  "subscribe/submitForm",
  async (subscribeForm) => {
    const response = await axios.post(SUBSCRIBE_URL, subscribeForm, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  }
);

const subscribeSlice = createSlice({
  name: "subscribe",
  initialState,
  reducers: {
    onSubmit(state, action) {
      console.log("update", action);
      state.status = "loading";
    },
    resetForm(state, action) {
      state.status = "idle";
      state.error = null;
      state.message = "";
      state.subscribeForm = {};
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchCountries.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchCountries.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.countries = action.payload;
      })
      .addCase(fetchUserCountry.fulfilled, (state, action) => {
        if (action?.payload?.country_code) {
          state.userCountry = action.payload.country_code;
        }
      })
      .addCase(submitSubscribeForm.pending, (state, action) => {
        state.status = "onSubmit";
      })
      .addCase(submitSubscribeForm.fulfilled, (state, action) => {
        if (bouncedMessage === action.payload) {
          state.status = "error";
          state.message = action.payload.replace(/<\/?[^>]+(>|$)/g, "");
          return;
        }
        state.status = "success";
        state.message =
          action.payload === 1 ? "You're subscribed!" : action.payload;
      });
  },
});

export const getCountries = (state) => state.subscribe.countries;
export const getStatus = (state) => state.subscribe.status;
export const getUserCountry = (state) => state.subscribe.userCountry;
export const getMessage = (state) => state.subscribe.message;

export const { onSubmit, resetForm } = subscribeSlice.actions;

export default subscribeSlice.reducer;
